import React, {
    createContext,
    useState,
    useContext,
    ReactNode,
    Dispatch,
    SetStateAction,
} from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";
import { CompanyType } from "../../../Models/Company";

interface IndexCompaniesProviderProps {
    children: ReactNode;
    callback?: () => void;
    type: CompanyType;
}

interface IndexCompaniesContextValue {
    modalConfig: ModalConfig;
    setModalConfig: Dispatch<SetStateAction<ModalConfig>>;
    callback?: () => void;
    type: CompanyType;
}

const IndexCompaniesContext = createContext<
    IndexCompaniesContextValue | undefined
>(undefined);

const IndexCompaniesProvider: React.FC<IndexCompaniesProviderProps> = ({
    children,
    callback,
    type
}) => {
    const [modalConfig, setModalConfig] = useState<ModalConfig>(
        createModalConfig()
    );

    return (
        <IndexCompaniesContext.Provider
            value={{ modalConfig, setModalConfig, callback, type }}
        >
            {children}
        </IndexCompaniesContext.Provider>
    );
};

const useIndexCompaniesContext = (): IndexCompaniesContextValue => {
    const context = useContext(IndexCompaniesContext);
    if (!context) {
        throw new Error(
            "useIndexCompaniesContext must be used within an IndexCompaniesProvider"
        );
    }
    return context;
};

export { IndexCompaniesProvider, useIndexCompaniesContext };